/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderIcon20Solid = forwardRef('FolderIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h4.3a1.5 1.5 0 0 1 1.205.607l.807 1.09a.75.75 0 0 0 .603.303H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8c0-.069.002-.138.007-.205a1.201 1.201 0 0 0-.002-.176A1.524 1.524 0 0 1 2 7.5v-3ZM5 8a.75.75 0 0 0 0 1.5h10A.75.75 0 0 0 15 8H5Z" })));
});
